






import Class from './c-content-chart-sphere-tones-bar';
export default Class;
